import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ClientsListPage from '../components/ClientListPage'
import {
  actionCreators,
  IClientsListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/clientsList'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IClientsListState>({
      error: selectError(),
      filterText: selectFilterText(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      totalItems: selectTotalItems(),
    }),
    actionCreators,
  )(ClientsListPage),
)
